import {
  SET_MODAL_VISIBLE,
  SET_LINKING_STATUS_CODE,
  SET_REQUEST_LOADING,
  SET_HAS_ERROR_LINKING,
  SET_SUCCESS_LINKING,
  SET_API_ERROR_EMAIL,
  SET_API_ERROR_PASSWORD,
  SET_API_ERROR_GLOBAL,
  CLEAR_API_ERRORS
} from './mutations-types'

export default {
  [SET_MODAL_VISIBLE] (state, value) {
    state.isModalVisible = value
  },
  [SET_LINKING_STATUS_CODE] (state, code) {
    state.linkingStatusCode = code
  },
  [SET_REQUEST_LOADING] (state, value) {
    state.isRequestLoading = value
  },
  [SET_HAS_ERROR_LINKING] (state, value) {
    state.hasErrorLinking = value
  },
  [SET_SUCCESS_LINKING] (state, value) {
    state.successLinking = value
  },
  [SET_API_ERROR_EMAIL] (state, code) {
    state.apiErrors.emailCode = code
  },
  [SET_API_ERROR_PASSWORD] (state, code) {
    state.apiErrors.passwordCode = code
  },
  [SET_API_ERROR_GLOBAL] (state, code) {
    state.apiErrors.globalCode = code
  },
  [CLEAR_API_ERRORS] (state) {
    state.apiErrors.emailCode = null
    state.apiErrors.passwordCode = null
    state.apiErrors.globalCode = null
  }
}
